<script>
    import { navigate } from "svelte-routing";
    import InputField from "../../components/Forms/InputField.svelte";
    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import { sendToken } from "../../services/subscribersService";
    import toast from "svelte-french-toast";
    import ButtonPromise from "../../components/Button/ButtonPromise.svelte";

    let subscriptionRenewPromise = null;

    const { form, handleSubmit, handleChange, errors, validateField, isValid } = createForm({
        initialValues: { email: "" },
        validationSchema: yup.object().shape({
            email: yup.string().email("Inserisci una mail corretta").required("Inserisci una e-mail")
        }),
    });

    async function sendSubscriptionRenewRequest() {
        await validateField("email");

        if (!$isValid) {
            return;
        }

        subscriptionRenewPromise = (async () => {
            try {
                await sendToken($form.email, "renew_membership");
                toast.success(
                    "La mail con il link per rinnovare l'iscrizione è stata mandata alla sua casella postale.",
                    {duration: 8000}
                );
                navigate("/", {replace: true});
            } catch (e) {
                toast.error("Non è stato possibile mandare la mail, riprovi più tardi");
            } finally {
                subscriptionRenewPromise = null;
            }
        })();
    }
</script>

<div class="min-h-600-px flex justify-center w-full">
    <div class="flex flex-col content-color select-none gap-6 h-full w-full md:w-8/12 xl:w-4/12">
        <div class="text-2xl mt-4">
            Se hai già effettuato l'iscrizione uno degli scorsi anni da questo sito recupera i dati inserendo la tua email.
<!--            , oppure-->
<!--            <a-->
<!--                use:link-->
<!--                href="/iscriviti"-->
<!--                class="red-si"-->
<!--            >-->
<!--                procedi con una nuova iscrizione.-->
<!--            </a>-->
        </div>

        <form class="w-full flex flex-col gap-1" on:submit|preventDefault={handleSubmit}>
            <div class="text-xl">Inserisci la tua email</div>

            <InputField
                placeholder="Email"
                name="email"
                bind:errorText={$errors.email}
                bind:value={$form.email}
                handleChange={handleChange}
            />

            <div class="w-full flex flex-col gap-4 mt-3">
                <ButtonPromise
                    handleClick="{() => sendSubscriptionRenewRequest()}"
                    promise="{subscriptionRenewPromise}"
                    content="Inserisci la mail"
                    buttonClass="w-64 h-9 bg-lb first-button cursor-pointer rounded section-title py-1"
                />

<!--                <Button-->
<!--                    handleClick="{() => navigate('/iscriviti')}"-->
<!--                    content="Nuova iscrizione"-->
<!--                    buttonClass="w-64 h-9 bg-lb second-button cursor-pointer rounded section-title py-1"-->
<!--                />-->
            </div>
        </form>
    </div>
</div>